<template>
  <div v-if="status" dir="rtl" class="modal__error slide-top" style="z-index: 999999999999999; top: 47%; width: 90vw; height: 40vw;">
    <div>
      <p>زنجیره نتایج - {{title}}</p>
      <p @click.prevent="$emit('close')">❌</p>
    </div>
    <div>
    <div class="d-flex flex-column w-100">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h1 style="font-size: 1vw !important">خروجی</h1>
         <div class="table-responsive" style="width: 100%;height: 10vw;">
        <table class="table table-striped bg-white" style="width: 70vw; ">
          <thead>
          <tr>
            <th style="width: 1vw;">ردیف</th>
            <th> عنوان</th>
            <th style="width: 7vw;"> مقدار (واحد)</th>
          </tr>
          </thead>
          <tbody>
          <tr >
            <td>1</td>
            <td>{{definition_of_outputs.title}}</td>
            <td><input type="number" v-model="definition_of_outputs.value" class="form-control"></td>
          </tr>
          </tbody>
        </table>
 </div>
      </div>
     <center>
       <hr class="w-75">
     </center>
      <div class="d-flex flex-column align-items-center justify-content-center mt-3">
        <h1 style="font-size: 1vw !important">پیامد</h1>
        <div class="table-responsive" style="width: 100%;height: 12vw;">
          <table class="table table-striped bg-white" style="width: 70vw; ">
            <thead>
            <tr class="sticky-header">
              <th style="width: 1vw;">ردیف</th>
              <th> عنوان</th>
              <th style="width: 7vw;"> مقدار (واحد)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in intermediate_outcomes">
              <td>{{ index+1 }}</td>
              <td>{{item.title}}</td>
              <td><input type="number" v-model="item.value" class="form-control"></td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>




      <!-- محتوای دیگر -->
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20%; position:fixed; bottom: 0; border-top: 1px solid #999;">
        <button @click.prevent="$emit('close')" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click.prevent="saveItems" class="btn btn-primary btn-submit-1" type="submit">ذخیره نهایی</button>
      </div>
    </div>
  </div>
</template>

<script>
import InputsInformationsItem from "@/components/Impact_Assessment/Input/InputsInformationsItem.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  components: {InputsInformationsItem},
  props: {
    show_insert: Boolean,
    status: Boolean,
    title: String,
    id: Number,
    issue_id:Number,
    intermediate_outcomes: Array,
    definition_of_outputs: Array
  },

methods:{
  saveItems(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
    var formdata = new FormData();
    formdata.append('p_id', this.id)
    formdata.append('intermediate_outcomes', JSON.stringify(this.intermediate_outcomes))
    formdata.append('definition_of_outputs', JSON.stringify(this.definition_of_outputs))
    formdata.append('issue_id', this.issue_id)
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(`${this.base_url}/impact-assessment/store_chain`, requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.error) {
            toast.error(result.error)
            return
          }
          if (result.message){
            toast.success(result.message)

          }




        })
        .catch();
  },
},

  mounted() {
  }
};
</script>
